export default __webpack_public_path__ + "static/media/Hoisery.eeaa7273.webp";